import {
  Autocomplete,
  AutocompleteRenderInputParams,
  AutocompleteRenderValueGetItemProps,
  Chip,
  TextField,
} from '@mui/material'
import { useContext } from 'react'
import { FieldValues } from 'react-hook-form'

import { FilterableListBoxContext } from 'components/FilterableListBox'
import { ChipsInputProps } from './types'

export const ChipsInput = <T extends FieldValues>({
  disabled,
  name,
  onChange,
  value,
}: ChipsInputProps<T>): React.JSX.Element => {
  const { filter } = useContext(FilterableListBoxContext)

  const isFiltered = (option: string): boolean => !filter || option.includes(filter)

  return (
    <Autocomplete
      className='ChipsListFilterable'
      disableClearable
      disabled={disabled}
      freeSolo
      fullWidth
      id={name}
      multiple
      onChange={(_, values: string[]): void => onChange(values)}
      open={false}
      options={[]}
      renderInput={(props: AutocompleteRenderInputParams) => <TextField {...props} />}
      renderValue={(value: string[], getTagProps: AutocompleteRenderValueGetItemProps<true>) =>
        value.map(
          (option: string, index: number): React.JSX.Element =>
            isFiltered(option) ? (
              <Chip
                {...getTagProps({ index })}
                key={option}
                label={option}
              />
            ) : (
              <></>
            ),
        )
      }
      value={value}
    />
  )
}
